/**
 * RUT chileno — espejo de `backend/app/core/rut.py`.
 *
 * Canónico (lo que guarda el backend): `12345678-5`. Presentación: `12.345.678-5`.
 */

const LIMPIAR = /[^0-9kK]/g;

export function calcularDv(cuerpo: string): string {
  let suma = 0;
  let mult = 2;
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += Number(cuerpo[i]) * mult;
    mult = mult === 7 ? 2 : mult + 1;
  }
  const resto = 11 - (suma % 11);
  if (resto === 11) return "0";
  if (resto === 10) return "K";
  return String(resto);
}

/** `' 12.345.678-5 '` → `'12345678-5'`, o `null` si el formato/DV no es válido. */
export function normalizarRut(raw: string): string | null {
  const limpio = (raw ?? "").replace(LIMPIAR, "").toUpperCase();
  if (limpio.length < 2) return null;
  const cuerpo = limpio.slice(0, -1);
  const dv = limpio.slice(-1);
  if (!/^\d{6,8}$/.test(cuerpo)) return null;
  if (calcularDv(cuerpo) !== dv) return null;
  return `${cuerpo}-${dv}`;
}

export function rutValido(raw: string): boolean {
  return normalizarRut(raw) !== null;
}

/** Cualquier forma → `12.345.678-5`. No valida; texto raro se devuelve igual. */
export function formatRut(rut: string | null | undefined): string {
  if (!rut) return "";
  const limpio = rut.replace(LIMPIAR, "").toUpperCase();
  if (limpio.length < 2 || !/^\d+$/.test(limpio.slice(0, -1))) return rut;
  const cuerpo = limpio.slice(0, -1);
  const dv = limpio.slice(-1);
  return `${cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}-${dv}`;
}

/** Mensaje para el form cuando el RUT no es válido (null si está bien). */
export function errorRut(raw: string): string | null {
  const limpio = (raw ?? "").replace(LIMPIAR, "").toUpperCase();
  if (limpio.length < 2) return "RUT incompleto";
  const cuerpo = limpio.slice(0, -1);
  if (!/^\d{6,8}$/.test(cuerpo)) return "RUT inválido";
  const dv = calcularDv(cuerpo);
  if (dv !== limpio.slice(-1)) return `Dígito verificador incorrecto (debería ser ${dv})`;
  return null;
}
